import { defineMessages } from 'react-intl';

export default defineMessages({
  createLabel: {
    id: 'view.button.create',
    defaultMessage: 'Create',
  },
  sparePartRequest: {
    id: 'view.nav.items.createSparePartRequest',
    defaultMessage: 'Spare parts request',
  },
});
